import React, { useEffect, useState } from "react";
import { getUserAccount } from "../services/userServices";
import { toAuthState } from "../dto/auth.dto";

const UserContext = React.createContext(null);

const UserProvider = ({ children }) => {
  const initialState = { isLoading: true, isAuthenticated: false, account: {}, userData: {} };
  const [user, setUser] = useState(initialState);

  useEffect(() => {
    getUserAccount()
      .then((response) => setUser(toAuthState(response) || { ...initialState, isLoading: false }))
      .catch(() => setUser({ ...initialState, isLoading: false }));
  }, []);

  return (
    <UserContext.Provider value={{
      user,
      loginContext: (data) => setUser({ ...data, isLoading: false }),
      logoutContext: () => setUser({ ...initialState, isLoading: false }),
    }}>
      {children}
    </UserContext.Provider>
  );
};

export { UserContext, UserProvider };
